module.exports = __webpack_public_path__ + "static/media/med_pomagala_vector.24ffe5cc.svg";